import { lazy } from "react";
import { RouterItemType } from "@/app/index";
import env from "@/app/config/env";
import { serviceBusinessUnitsApi } from "@/services/business-units";
import { serviceServicesApi } from "@/services/services";
import { BusinessUnitItemType } from "@/schemas/business-unit/business-unit-item";
import { ServiceProductItemType } from "@/schemas/services/service-product-item";

const LayoutPageTrialConfirmed = lazy(() => import("./layout/index"));

/**
 * The concierge onboarding call is booked through the regular appointments
 * API against the service product configured per environment
 * (VITE_*_REFERRAL_CONCIERGE_PRODUCT_ID; beta: 9d31d9db-44b0-f111-aaac-00224808dc3a).
 * TODO(551680): the production id is not known yet, so environments without a
 * configured id fall back to resolving the product by name.
 */
const CONCIERGE_PRODUCT_PATTERN = /concierge|onboarding/i;

export type LoaderDataTrialConfirmedType = {
  businessUnits: BusinessUnitItemType[];
  /** null when the concierge product is missing from the CSO configuration. */
  conciergeProduct: ServiceProductItemType | null;
  conciergeServiceName: string;
};

export const loaderDataTrialConfirmed = async () => {
  try {
    const [businessUnitsResponse, productsResponse, servicesResponse] =
      await Promise.all([
        serviceBusinessUnitsApi.fetchBusinessUnits(0, 100, ""),
        serviceServicesApi.fetchServiceProducts(),
        serviceServicesApi.fetchServiceTypes(),
      ]);

    const products = productsResponse || [];

    const conciergeProduct =
      products.find((product) => product.Id === env.referral.conciergeProductId) ||
      products.find((product) =>
        CONCIERGE_PRODUCT_PATTERN.test(product.Name || ""),
      ) ||
      null;

    const conciergeService = (servicesResponse || []).find(
      (service) => service.Id === conciergeProduct?.ServiceTypeId,
    );

    const dataLoader: LoaderDataTrialConfirmedType = {
      businessUnits: businessUnitsResponse.Results || [],
      conciergeProduct,
      conciergeServiceName: conciergeService?.Name || "",
    };

    return dataLoader;
  } catch (err) {
    console.log(err);
    throw new Error("DATA_NOT_FOUND");
  }
};

export const routerPageTrialConfirmed: RouterItemType = {
  path: "/trial-confirmed",
  authorize: true,
  element: <LayoutPageTrialConfirmed />,
  loader: loaderDataTrialConfirmed,
};
